<template>
  <pt-detection-corpus-structure-new class="pt-detection-corpus-structure-new__page"></pt-detection-corpus-structure-new>
</template>

<script>
import PtDetectionCorpusStructureNew from 'cps/gene-product/pt-detection-corpus-structure-new/withData'
export default {
  name: 'pt-detection-corpus-structure-new__view',
  components: {
    'pt-detection-corpus-structure-new': PtDetectionCorpusStructureNew
  }
}
</script>
